module.exports = __webpack_public_path__ + "static/media/ooc-logo.5d031268.png";